











































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { BigNumber } from 'ethers';
import { TransactionReceipt } from '@ethersproject/providers';
import { addSeconds } from 'date-fns';
import { ExternalWallet, CopyToClipboard, TextOutput } from '~/mixins';
import cancelOrderMutation from '~/mutations/order/cancelOrder.gql';
import UpdateOrderPaymentInfo from '~/mutations/order/updateOrderPaymentInfo.gql';
import ProgressRing from '~/components/UIComponents/ProgressRing.vue';
import {
  IBatchBridgeItemsActionPayload,
  IBridgeItemActionPayload,
} from '~/types/vuex_payloads/bridge_item';
import { SelectedUserItem } from '~/types/batch-bridge';
import { IBridgeCurrencyActionPayload } from '~/types/vuex_payloads/bridge_currency';
import { UserItem } from '~/types/user-items';
import { IWallet } from '~/store/inventory/types';

interface IProviderRpcError extends Error {
  message: string;
  code: number;
  data?: unknown;
}

interface IStepStrings {
  title: string;
  heading: string;
  buttonText: string;
  description: string;
}

enum TransactionAction {
  order = 'order',
  transfer = 'transfer',
  exchange = 'exchange',
  bridge = 'bridge',
}

@Component({ components: { ProgressRing } })
export default class Web3WalletPayment extends Mixins(
  ExternalWallet,
  CopyToClipboard,
  TextOutput,
) {
  @Prop(Number) blockSigned!: number;
  @Prop(Function) close!: () => void;
  @Prop(String) contractMethod!: string;
  @Prop(String) currency!: string;
  @Prop(Array) inputs!: any[];
  @Prop(String) paymentAmount!: string;
  @Prop(Number) quantity!: number;
  @Prop(String) refId!: string;
  @Prop(String) rewardImage!: string;
  @Prop(String) rewardName!: string;
  @Prop(String) smartContractAbi!: string;
  @Prop(String) smartContractAddress!: string;
  @Prop(String) transactionAction!: TransactionAction;
  @Prop(Number) transactionFeePrice!: number;
  @Prop(Object) item!: UserItem;
  @Prop(Array) selectedItems!: SelectedUserItem[];
  @Prop(Object) bridgeFromWallet!: IWallet;

  @Action('bridgeItem', { namespace: 'inventory' })
  private bridgeItem!: (payload: IBridgeItemActionPayload) => any;
  @Action('bridgeCurrency', { namespace: 'inventory' })
  private bridgeCurrency!: (payload: IBridgeCurrencyActionPayload) => any;
  @Action('batchBridgeItems', { namespace: 'inventory' })
  private batchBridgeItems!: (payload: IBatchBridgeItemsActionPayload) => any;

  activeStep = 0;
  transactionHash: null | string = null;
  errorMessage = '';
  errorHeading = this.$t('common.notifications.transactionFailed');
  txReceipt: null | TransactionReceipt = null;
  expirationTimestamp: null | number = null;

  get strings(): Record<
    TransactionAction,
    {
      step1: IStepStrings;
      step2: IStepStrings;
      step3: IStepStrings;
      expiredHeading: string;
      expiredMessage: string;
    }
  > {
    return {
      [TransactionAction.order]: {
        step1: {
          title: this.getTranslatedString('pending'),
          heading: this.getTranslatedString('orderPending'),
          buttonText: this.getTranslatedString('cancelOrder'),
          description: this.getTranslatedString('step1OrderDescription'),
        },
        step2: {
          title: this.getTranslatedString('processing'),
          heading: this.getTranslatedString('orderProcessing'),
          buttonText: this.getTranslatedString('exploreNfts'),
          description: this.getTranslatedString('step2OrderDescription'),
        },
        step3: {
          title: this.getTranslatedString('complete'),
          heading: this.getTranslatedString('orderComplete'),
          buttonText: this.getTranslatedString('goToInventory'),
          description: this.getTranslatedString('step3OrderDescription'),
        },
        expiredHeading: this.getTranslatedString('orderExpiredHeading'),
        expiredMessage: this.getTranslatedString('orderExpiredMessage'),
      },
      [TransactionAction.transfer]: {
        step1: {
          title: this.getTranslatedString('pending'),
          heading: this.getTranslatedString('conversionPending'),
          buttonText: this.getTranslatedString('cancelConversion'),
          description: this.getTranslatedString('step1ConversionDescription'),
        },
        step2: {
          title: this.getTranslatedString('processing'),
          heading: this.getTranslatedString('transactionProcessing'),
          buttonText: this.getTranslatedString('goToInventory'),
          description: this.getTranslatedString('step2ConversionDescription'),
        },
        step3: {
          title: this.getTranslatedString('confirmed'),
          heading: this.getTranslatedString('paymentConfirmed'),
          buttonText: this.getTranslatedString('goToInventory'),
          description: this.getTranslatedString('step3ConversionDescription', {
            rewardName: this.rewardName,
          }),
        },
        expiredHeading: this.getTranslatedString('transferExpiredHeading'),
        expiredMessage: this.getTranslatedString('transferExpiredMessage'),
      },
      [TransactionAction.exchange]: {
        step1: {
          title: this.getTranslatedString('pending'),
          heading: this.getTranslatedString('orderPending'),
          buttonText: this.getTranslatedString('cancelOrder'),
          description: this.getTranslatedString('step1OrderDescription'),
        },
        step2: {
          title: this.getTranslatedString('processing'),
          heading: this.getTranslatedString('orderProcessing'),
          buttonText: this.getTranslatedString('exploreNfts'),
          description: this.getTranslatedString('step2OrderDescription'),
        },
        step3: {
          title: this.getTranslatedString('complete'),
          heading: this.getTranslatedString('orderComplete'),
          buttonText: this.getTranslatedString('goToInventory'),
          description: this.getTranslatedString('step3OrderDescription'),
        },
        expiredHeading: this.getTranslatedString('orderExpiredHeading'),
        expiredMessage: this.getTranslatedString('orderExpiredMessage'),
      },
      [TransactionAction.bridge]: {
        step1: {
          title: this.getTranslatedString('pending'),
          heading: this.getTranslatedString('orderPending'),
          buttonText: this.getTranslatedString('cancelOrder'),
          description: this.getTranslatedString('step1BridgeDescription'),
        },
        step2: {
          title: this.getTranslatedString('processing'),
          heading: this.getTranslatedString('orderProcessing'),
          buttonText: this.getTranslatedString('exploreNfts'),
          description: this.getTranslatedString('step2OrderDescription'),
        },
        step3: {
          title: this.getTranslatedString('complete'),
          heading: this.getTranslatedString('orderComplete'),
          buttonText: this.getTranslatedString('goToInventory'),
          description: this.getTranslatedString('step3OrderDescription'),
        },
        expiredHeading: this.getTranslatedString('orderExpiredHeading'),
        expiredMessage: this.getTranslatedString('orderExpiredMessage'),
      },
    };
  }

  get steps() {
    return [
      {
        title: this.strings[this.transactionAction].step1.title,
        active: this.activeStep === 0,
        class: 'right-point',
        complete: this.activeStep > 0,
        heading: this.strings[this.transactionAction].step1.heading,
        buttonAction: this.close,
        buttonText: this.strings[this.transactionAction].step1.buttonText,
        description: this.strings[this.transactionAction].step1.description,
      },
      {
        title: this.strings[this.transactionAction].step2.title,
        active: this.activeStep === 1,
        class: 'chevron',
        complete: this.activeStep > 1,
        heading: this.strings[this.transactionAction].step2.heading,
        buttonAction: () =>
          this.$router.push(
            this.transactionAction === TransactionAction.order
              ? '/store'
              : '/inventory',
          ),
        buttonText: this.strings[this.transactionAction].step2.buttonText,
        description: this.strings[this.transactionAction].step2.description,
      },
      {
        title: this.strings[this.transactionAction].step3.title,
        active: this.activeStep === 2,
        class: 'left-point',
        complete: this.activeStep > 2,
        heading: this.strings[this.transactionAction].step3.heading,
        buttonAction: () => this.$router.push('/inventory'),
        buttonText: this.strings[this.transactionAction].step3.buttonText,
        description: this.strings[this.transactionAction].step3.description,
      },
    ];
  }

  get heading() {
    return this.errorMessage
      ? this.errorHeading
      : this.steps[this.activeStep].heading;
  }

  get description() {
    return this.errorMessage || this.steps[this.activeStep].description;
  }

  get button() {
    const activeStep = this.steps[this.activeStep];
    const action = this.errorMessage ? this.close : activeStep.buttonAction;
    const text = this.errorMessage
      ? this.getTranslatedString('tryAgain')
      : activeStep.buttonText;
    return { action, text };
  }

  get truncatedTransactionHash() {
    const hash = this.transactionHash;
    if (hash) {
      const string = `${hash.slice(0, 18)}....${hash.substr(
        hash.length - 4,
        hash.length,
      )}`;

      return string;
    }

    return '';
  }

  get bridgeTargetDestinationChainIds() {
    function getBridgeIdData(item: SelectedUserItem | UserItem) {
      if (item?.canBridgeTo?.length && item.canBridgeTo.length >= 1) {
        return item.canBridgeTo[0].destinationChainIds || [];
      }
      return [];
    }
    if (this.item) {
      return getBridgeIdData(this.item);
    } else if (this.selectedItems && this.selectedItems[0]) {
      return getBridgeIdData(this.selectedItems[0]);
    }

    return [];
  }

  getTranslatedString(path: string, params?: any[] | { [key: string]: any }) {
    return params
      ? (this.$t(
          `components.store.web3WalletPayment.${path}`,
          params,
        ) as string)
      : (this.$t(`components.store.web3WalletPayment.${path}`) as string);
  }

  async cancelOrder(paymentError: boolean = false, error?: string) {
    if (this.transactionAction !== TransactionAction.order) {
      return;
    }
    const variables = {
      orderId: this.refId,
      paymentError,
      error,
    };
    const { data } = await this.$apollo.mutate({
      mutation: cancelOrderMutation,
      variables,
    });
    return data;
  }

  async handleSuccessfulPayment(transactionHash: string) {
    if (this.transactionAction === TransactionAction.bridge) {
      if (this.item) {
        await this.bridgeItem({
          item: this.item,
          quantity: this.quantity,
          transactionHash,
        });
      } else if (this.selectedItems) {
        const botToken = await this.$recaptcha.execute('batchBridge');
        await this.batchBridgeItems({
          selectedTokens: this.selectedItems,
          transactionHash,
          totpToken: '',
          botToken,
          destinationChainId: this.bridgeTargetDestinationChainIds[0],
        });
      } else {
        await this.bridgeCurrency({
          wallet: this.bridgeFromWallet,
          targetNetwork: 'GYRI',
          quantity: this.quantity,
          transactionHash,
        });
      }
    }

    if (
      ![TransactionAction.order, TransactionAction.exchange].includes(
        this.transactionAction,
      )
    ) {
      return;
    }
    const variables = {
      orderId: this.refId,
      transactionHash,
    };

    try {
      const { data } = await this.$apollo.mutate({
        mutation: UpdateOrderPaymentInfo,
        variables,
      });

      this.$ua.trackPurchaseCompleteEvent({
        isSuccessful: data.updateOrderPaymentInfo.success,
        paymentHash: variables.transactionHash,
        results: {},
      });
      return data;
    } catch (error) {
      this.$sentry.captureException(error);
    }
  }

  async initPayment() {
    // build transaction data
    const abi = JSON.parse(this.smartContractAbi);
    const iface = this.buildIface(abi);

    try {
      const transactionData = iface.encodeFunctionData(
        this.contractMethod,
        this.inputs,
      );
      // Estimate gas using contract
      const contractInstance = this.getContractInstance(
        this.smartContractAddress,
        this.smartContractAbi,
      );

      const estimateGasParams: any = [...this.inputs];
      if (this.currency === 'ETH') {
        estimateGasParams.push({
          value: BigNumber.from(this.paymentAmount),
        });
      }

      const gasEstimate = await contractInstance.estimateGas[
        this.contractMethod
      ](...estimateGasParams);

      if (this.blockSigned) {
        // calculate timer time
        const blockMaxThreshold = await contractInstance.blockMaxThreshold();
        const currentBlock = await this.web3Provider?.getBlockNumber();

        const blocksRemaining =
          this.blockSigned +
          blockMaxThreshold.toNumber() -
          (currentBlock || this.blockSigned);
        this.expirationTimestamp = addSeconds(
          new Date(),
          blocksRemaining * 13,
        ).getTime();
      }

      // Prompt w3w provider to open and complete transaction
      const tx = await this.signTransaction({
        destinationAddress: this.smartContractAddress,
        transactionFeePrice: this.transactionFeePrice,
        data: transactionData,
        amount: this.currency === 'ETH' ? this.paymentAmount : '0',
        gasEstimate: gasEstimate.toNumber(),
      });

      if (tx) {
        this.transactionHash = tx.hash;
        await this.handleSuccessfulPayment(this.transactionHash);
        this.activeStep = 1;
        const receipt = await tx.wait();
        this.txReceipt = receipt;
      }
    } catch (err) {
      this.$sentry.captureException(err);
      const error = err as IProviderRpcError;
      await this.cancelOrder(false, JSON.stringify(err));
      if (error?.code === 4001) {
        this.errorHeading = this.getTranslatedString(
          'transactionRejectedHeading',
        );
        this.errorMessage = this.getTranslatedString(
          'transactionRejectedMessage',
        );
      } else {
        // TODO: handle other error codes to provide more descriptive user-facing error message
        this.errorMessage = this.getTranslatedString('transactionFailed');
      }
    }
  }

  handleExpired() {
    if (!this.transactionHash && this.activeStep === 0) {
      this.errorMessage = this.strings[this.transactionAction].expiredMessage;
      this.errorHeading = this.strings[this.transactionAction].expiredHeading;
    }
  }

  @Watch('web3Provider', { immediate: true })
  onProviderReady(web3Provider: any) {
    if (!this.transactionHash) {
      if (web3Provider.network) {
        this.initPayment();
      } else {
        web3Provider.on('network', () => this.initPayment());
      }
    }
  }

  @Watch('txReceipt')
  onTxReciept(txReceipt: TransactionReceipt) {
    if (txReceipt) {
      this.activeStep = 2;
      this.$emit('complete', {
        orderId: this.refId,
        transactionHash: txReceipt.transactionHash,
      });
    }
  }
}
